import { z } from "zod";
import { sessionStore } from "../../../lib/store";

/**
 * Last room/playlist IDs for which we persisted a scroll offset, used to
 * decide whether to restore scroll on back-nav or start fresh.
 */
const PlaylistScrollContextSchema = z.object({
  lastListRoomId: z.string().nullable(),
  lastDetailPlaylistId: z.string().nullable(),
});

const initialPlaylistScrollContext: z.infer<
  typeof PlaylistScrollContextSchema
> = {
  lastListRoomId: null,
  lastDetailPlaylistId: null,
};

export const playlistScrollStore = sessionStore(
  "playlist-scroll",
  initialPlaylistScrollContext,
  PlaylistScrollContextSchema
);
